import { FC } from 'react';
// Interfaces
import { IconSvgProps } from '@utmb/types/icons';

const Checkbox: FC<IconSvgProps> = ({ color, clss, width = 19, height = 19 }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 19 19" className={clss}>
            <g fill="none" fillRule="evenodd">
                <g strokeLinecap="round">
                    <path stroke={color} strokeWidth="1.5" d="M4.996 8.044l3.01 2.76L13.007 6" />
                </g>
            </g>
        </svg>
    );
};

export default Checkbox;
